import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import About from './section-components/about-v2';
import Event from './section-components/event';
import Quotes from './section-components/quotes';
import Mission from './section-components/mission';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const AboutPage = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best Training Institute in Chennai | Coaching Centre in Chennai</title>
            <meta name="description" content="MIET in Chennai offers best training and coaching for all levels of education. Provides customized syllabus and training for students. Call us to know more" />
        </Helmet>
        <PageHeader headertitle="About Us"  />
        <About/>
        <Quotes />
        <Mission />
        <Event />
        <Footer />
    </div>
}

export default AboutPage

